'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = function (_Component) {
    _inherits(TextInput, _Component);

    function TextInput(props) {
        _classCallCheck(this, TextInput);

        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

        _this.handleChange = function (e) {
            var value = e.target.value;

            _this.setState({ value: value });

            if (!_this.props.updateValueOnBlur) {
                _this.updateValue(value);
            }
        };

        _this.handleFocus = function () {
            _this.setState({ focussed: true });

            _this.props.handleFocus && _this.props.handleFocus();
        };

        _this.handleBlur = function () {
            _this.setState({ focussed: false });

            if (_this.props.updateValueOnBlur) {
                _this.updateValue(_this.state.value);
            }

            _this.props.handleBlur && _this.props.handleBlur();
        };

        _this.state = {
            focussed: false,
            tooltipPosition: null,
            value: props.value || ''
        };
        return _this;
    }

    _createClass(TextInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                this.setState({
                    value: nextProps.value || ''
                });
            }
        }
    }, {
        key: 'updateValue',
        value: function updateValue(value) {
            if (value !== this.props.value) {
                this.props.updateValue(_defineProperty({}, this.props.name, value));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                disabled = _props.disabled,
                errors = _props.errors,
                help = _props.help,
                label = _props.label,
                max = _props.max,
                min = _props.min,
                name = _props.name,
                onKeyPress = _props.onKeyPress,
                placeholder = _props.placeholder,
                required = _props.required,
                rows = _props.rows,
                step = _props.step,
                success = _props.success,
                type = _props.type;
            var value = this.state.value;


            var inputId = (0, _Utils.generateId)(name);

            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': errors && errors.length,
                'form__group--success': success
            });

            var field = null;

            if (type === 'textarea') {
                field = _react2.default.createElement('textarea', {
                    autoFocus: autoFocus,
                    className: 'form__text form__textarea',
                    disabled: disabled,
                    id: inputId,
                    name: name,
                    onBlur: this.handleBlur,
                    onChange: this.handleChange,
                    onFocus: this.handleFocus,
                    onKeyPress: onKeyPress,
                    placeholder: placeholder,
                    ref: this.storeTextInputRef,
                    required: required,
                    rows: rows,
                    type: type,
                    value: value
                });
            } else {
                field = _react2.default.createElement('input', {
                    autoFocus: autoFocus,
                    className: 'form__text',
                    disabled: disabled,
                    id: inputId,
                    max: max,
                    min: min,
                    name: name,
                    onBlur: this.handleBlur,
                    onChange: this.handleChange,
                    onFocus: this.handleFocus,
                    onKeyPress: onKeyPress,
                    placeholder: placeholder,
                    ref: this.storeTextInputRef,
                    required: required,
                    step: step,
                    type: type,
                    value: value
                });
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    { htmlFor: inputId },
                    label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form__control' },
                    field
                ),
                _react2.default.createElement(_SubContent2.default, { errors: errors, help: help })
            );
        }
    }]);

    return TextInput;
}(_react.Component);

TextInput.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.focussablePropTypes, {

    autoFocus: _propTypes2.default.bool,
    max: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    min: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    onKeyPress: _propTypes2.default.func,
    placeholder: _propTypes2.default.string,
    required: _propTypes2.default.bool,
    rows: _propTypes2.default.number,
    step: _propTypes2.default.number,
    success: _propTypes2.default.bool,
    type: _propTypes2.default.string,
    updateValueOnBlur: _propTypes2.default.bool
});
TextInput.defaultProps = {
    autoFocus: false,
    disabled: false,
    placeholder: '',
    rows: 6,
    type: 'text',
    updateValueOnBlur: true
};
exports.default = TextInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/TextInput.js
// module id = 218
// module chunks = 0